<template>
  <div class="step-box" :class="align === 'right' ? 'right' : ''">
    <div class="step-item">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepNumber",
  props: {
    current: {
      type: Number,
      default: 0
    },
    // 靠左还是靠右
    align: {
      type: String,
      default: "left"
    },
    // step样式的选择 ordinary为待付款 confirm为购物车-核对订单
    chooseType: {
      type: String,
      default: "ordinary"
    }
  },
  data() {
    return {
      active: 0
    };
  },
  watch: {
    current: {
      immediate: true,
      handler() {
        this.changeIndex();
      }
    }
  },
  mounted() {
    this.changeIndex();
  },
  methods: {
    changeIndex() {
      let element = document.getElementsByClassName("step");
      if (this.chooseType === "ordinary") {
        if (element.length > 0) {
          Array.from(element).forEach((item, index) => {
            element[index].classList.remove("active");
          });
          element[this.current].classList.add("active");
        }
      } else if (this.chooseType === "confirm") {
        let ele = document.getElementsByClassName("step-container");
        if (ele.length > 0) {
          Array.from(ele).forEach((item, index) => {
            if (index < this.current) {
              ele[index].classList.add("on");
            } else if (index === this.current) {
              ele[index].classList.add("active");
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.step-box
  display flex
  &.right
    flex-direction row-reverse
  .step-item
    display flex
</style>
